{
  "menu.dashboard": "Dashboard",
  "menu.patients": "Patients",
  "menu.scheduling": "Scheduling",
  "menu.billing": "Billing",
  "menu.questionnaire": "Questionnaire",
  "menu.inventory": "Inventory",
  "menu.purchasing": "Purchasing",
  "menu.crm": "CRM",
  "menu.reporting": "Reporting",
  "menu.productivity": "Productivity",
  "menu.maintenance": "Maintenance",
  "menu.patients.all_patients": "All Patients",
  "menu.patients.new_patient": "New Patient",
  "menu.patients.prescription_summary": "prescription_noun Summary",
  "menu.patients.missing_notes": "Missing Notes",
  "menu.patients.checklist": "Checklist",
  "menu.patients.patient_intake_queue": "Patient Intake Queue",
  "menu.patients.new_patient_intake": "New Patient Intake",
  "menu.patients.batch_sign_swos": "Batch Sign SWOs",
  "menu.patients.ai_notes": "AI Notes",
  "menu.patients.lmn_dashboard": "LMN Dashboard",
  "menu.patients.parachute_intake_queue": "Parachute Intake Queue",
  "menu.scheduling.appointments": "Appointments",
  "menu.scheduling.calendar": "Calendar",
  "menu.billing.claims": "Claims",
  "menu.billing.bulk_claim_jobs": "Bulk Claim Jobs",
  "menu.billing.nymbl_payments": "Nymbl Payments",
  "menu.billing.era_payments": "ERA Payments",
  "menu.billing.posted_payments": "Posted Payments",
  "menu.billing.patient_statements": "Patient Statements",
  "menu.questionnaire.form_bank": "Form Bank",
  "menu.questionnaire.question_bank": "Question Bank",
  "menu.inventory.all_inventory": "All Inventory",
  "menu.inventory.inventory_transfers": "Inventory Transfers",
  "menu.inventory.item_history": "Item History",
  "menu.purchasing.shop_retail_suppliers": "Shop Retail Suppliers",
  "menu.purchasing.empire_purchase_orders": "Empire Purchase Orders",
  "menu.purchasing.pel_purchase_orders": "PEL Purchase Orders",
  "menu.purchasing.all_purchase_orders": "All Purchase Orders",
  "menu.purchasing.new_purchase_order": "New Purchase Order",
  "menu.purchasing.vendors": "Vendors",
  "menu.purchasing.shopping_cart": "Shopping Cart",
  "menu.purchasing.my_cart": "My Cart",
  "menu.crm.activities": "Activities",
  "menu.crm.add_activity": "Add Activity",
  "menu.reporting.financials": "Financials",
  "menu.reporting.financials.general_ledger": "General Ledger",
  "menu.reporting.financials.general_ledger.accounts_receivable": "Accounts Receivable",
  "menu.reporting.financials.general_ledger.sales": "Sales",
  "menu.reporting.financials.general_ledger.payments": "Payments",
  "menu.reporting.financials.general_ledger.adjustments": "Adjustments",
  "menu.reporting.financials.general_ledger.hcpc_payments": "HCPC Payments",
  "menu.reporting.financials.general_ledger.hcpc_sales": "HCPC Sales",
  "menu.reporting.financials.general_ledger.claims_activity": "Claims Activity",
  "menu.reporting.financials.payments": "Payments",
  "menu.reporting.financials.payments.zero_dollar": "Zero Dollar Payments",
  "menu.reporting.financials.payments.cash": "Cash",
  "menu.reporting.financials.balances": "Balances",
  "menu.reporting.financials.balances.outstanding": "Outstanding Balances",
  "menu.reporting.financials.item_transactions": "Item Transactions",
  "menu.reporting.scheduling": "Scheduling",
  "menu.reporting.scheduling.practitioner_appointments": "practitioner_noun Appointments",
  "menu.reporting.purchasing_inventory": "Purchasing & Inventory",
  "menu.reporting.purchasing_inventory.purchasing_history": "Purchasing History",
  "menu.reporting.efficiency": "Efficiency",
  "menu.reporting.efficiency.task_tracking": "Task Tracking",
  "menu.reporting.efficiency.new_patients": "New Patients",
  "menu.reporting.efficiency.prescription_timelines": "prescription_noun Timelines",
  "menu.reporting.efficiency.delivered_prescription_not_billed": "Delivered prescription_noun Not Billed",
  "menu.reporting.efficiency.prescription_status_change_tracking": "prescription_noun Status Change Tracking",
  "menu.reporting.efficiency.claim_status_change_tracking": "Claim Status Change Tracking",
  "menu.reporting.efficiency.note_completion_timelines": "Note Completion Timelines",
  "menu.reporting.efficiency.clerical_productivity": "Clerical Productivity",
  "menu.reporting.efficiency.patient_last_touch": "Patient Last Touch",
  "menu.reporting.productivity": "Productivity",
  "menu.reporting.productivity.actionable": "Actionable",
  "menu.reporting.productivity.actionable.rental_prescription_summary": "Rental prescription_noun Summary",
  "menu.productivity.tasks": "Tasks",
  "menu.productivity.add_task": "Add Task",
  "menu.maintenance.billing": "Billing",
  "menu.maintenance.billing.ar_adjustments": "AR Adjustments",
  "menu.maintenance.billing.claim_statuses": "Claim Statuses",
  "menu.maintenance.billing.clearing_house_accounts": "Clearing House Accounts",
  "menu.maintenance.billing.era_reason_codes": "ERA Reason Codes",
  "menu.maintenance.billing.prescription_statuses": "prescription_noun Statuses",
  "menu.maintenance.billing.device_types": "Device Types",
  "menu.maintenance.billing.diagnosis_codes": "Diagnosis Codes",
  "menu.maintenance.billing.insurance_companies": "Insurance Companies",
  "menu.maintenance.billing.hcpcs_fee_schedules": "HCPCS and Fee Schedules",
  "menu.maintenance.billing.gl_periods": "GL Periods",
  "menu.maintenance.billing.gl_accounts": "GL Accounts",
  "menu.maintenance.billing.nymbl_pay": "Nymbl Pay",
  "menu.maintenance.billing.form1500_printer_settings": "1500 Form Printer Settings",
  "menu.maintenance.billing.billing_rules": "Billing Rules",
  "menu.maintenance.branch_company": "Branch/Company",
  "menu.maintenance.branch_company.branches": "Branches",
  "menu.maintenance.branch_company.general_contacts": "General Contacts",
  "menu.maintenance.branch_company.medical_groups": "Medical Groups",
  "menu.maintenance.branch_company.user_groups": "User Groups",
  "menu.maintenance.branch_company.users": "Users",
  "menu.maintenance.purchasing": "Purchasing",
  "menu.maintenance.purchasing.items": "Items",
  "menu.maintenance.purchasing.vendors": "Vendors",
  "menu.maintenance.referral_sources": "Referral Sources",
  "menu.maintenance.referral_sources.physicians": "Physicians",
  "menu.maintenance.referral_sources.therapists": "Therapists",
  "menu.maintenance.referral_sources.facilities": "Facilities",
  "delivery_locations.empty.prompt": "Select a delivery location or create a new one.",
  "delivery_locations.list.search_placeholder": "Search delivery locations...",
  "delivery_locations.list.toggle_filters": "Toggle filters",
  "delivery_locations.list.address": "Street Address",
  "delivery_locations.list.phone": "Phone Number",
  "delivery_locations.list.empty": "No delivery locations found.",
  "delivery_locations.list.load_error_detail": "The delivery locations could not be loaded. Please try again.",
  "delivery_locations.form.title.new": "New Delivery Location",
  "delivery_locations.form.title.default": "Delivery Location",
  "delivery_locations.form.details": "Details",
  "delivery_locations.form.name": "Location Name *",
  "delivery_locations.form.name_required": "Location name is required.",
  "delivery_locations.form.npi": "NPI",
  "delivery_locations.form.npi_invalid": "Input must consist of exactly 10 numeric digits.",
  "delivery_locations.form.street": "Street",
  "delivery_locations.form.city": "City",
  "delivery_locations.form.state": "State",
  "delivery_locations.form.select": "Select",
  "delivery_locations.form.zipcode": "Zipcode",
  "delivery_locations.form.invalid_format": "Invalid format.",
  "delivery_locations.form.phone": "Phone Number",
  "delivery_locations.form.fax": "Fax Number",
  "delivery_locations.message.delete_in_use": "This delivery location is in use by one or more appointments and cannot be deleted.",
  "facilities.empty.prompt": "Select a facility or create a new one.",
  "facilities.list.search_placeholder": "Search facilities...",
  "facilities.list.toggle_filters": "Toggle filters",
  "facilities.list.status": "Status",
  "facilities.list.address": "Address",
  "facilities.list.phone": "Phone",
  "facilities.list.all": "All",
  "facilities.list.active": "Active",
  "facilities.list.inactive": "Inactive",
  "facilities.list.empty": "No facilities found.",
  "facilities.list.load_error_detail": "The facilities could not be loaded. Please try again.",
  "facilities.form.title.new": "New Facility",
  "facilities.form.title.default": "Facility",
  "facilities.form.details": "Facility Details",
  "facilities.form.name": "Facility Name *",
  "facilities.form.name_required": "Facility name is required.",
  "facilities.form.street": "Street",
  "facilities.form.city": "City",
  "facilities.form.state": "State",
  "facilities.form.select": "Select",
  "facilities.form.zipcode": "Zipcode",
  "facilities.form.invalid_format": "Invalid format.",
  "facilities.form.phone": "Phone Number",
  "facilities.form.fax": "Fax Number",
  "facilities.form.place_of_service": "Place of Service (POS)",
  "facilities.form.npi": "Facility NPI#",
  "facilities.form.npi_invalid": "Input must consist of exactly 10 numeric digits.",
  "facilities.form.alert": "Alert",
  "facilities.form.alert_message": "Alert Message",
  "facilities.message.delete_in_use": "This facility is attached to one or more prescriptions and cannot be deleted.",
  "facilities.message.search_failed": "Search failed",
  "facilities.message.load_failed": "Failed to load facilities.",
  "physicians.actions.search_npi": "Search NPI",
  "physicians.actions.verify_pecos": "Verify PECOS",
  "physicians.empty.prompt": "Select a physician or create a new one.",
  "physicians.list.search_placeholder": "Search physicians...",
  "physicians.list.toggle_filters": "Toggle filters",
  "physicians.list.status": "Status",
  "physicians.list.npi": "NPI",
  "physicians.list.upin": "UPIN",
  "physicians.list.facility_name": "Facility Name",
  "physicians.list.address": "Address",
  "physicians.list.phone": "Phone",
  "physicians.list.all": "All",
  "physicians.list.active": "Active",
  "physicians.list.inactive": "Inactive",
  "physicians.list.empty": "No physicians found.",
  "physicians.list.load_error_detail": "The physicians could not be loaded. Please try again.",
  "physicians.form.title.new": "New Physician",
  "physicians.form.title.default": "Physician",
  "physicians.form.details": "Physician Details",
  "physicians.form.last_name": "Last Name *",
  "physicians.form.last_name_required": "Last name is required.",
  "physicians.form.first_name": "First Name *",
  "physicians.form.first_name_required": "First name is required.",
  "physicians.form.middle_name": "Middle Name",
  "physicians.form.suffix": "Suffix",
  "physicians.form.credentials": "Credentials",
  "physicians.form.street": "Street *",
  "physicians.form.city": "City *",
  "physicians.form.state": "State *",
  "physicians.form.select": "Select",
  "physicians.form.zipcode": "Zipcode *",
  "physicians.form.invalid_format": "Invalid format.",
  "physicians.form.email": "Email",
  "physicians.form.npi": "NPI",
  "physicians.form.npi_invalid": "Input must consist of exactly 10 numeric digits.",
  "physicians.form.npi_not_found": "No matching provider was found in the NPI registry.",
  "physicians.form.npi_search_failed": "Could not search the NPI registry. Please try again.",
  "physicians.form.upin": "UPIN",
  "physicians.form.upin_invalid": "Input must consist of exactly 6 alphanumeric characters.",
  "physicians.form.pecos_verified": "PECOS Status",
  "physicians.form.pecos_verified_tooltip": "Verified with PECOS.",
  "physicians.form.pecos_expired_tooltip": "PECOS verification has expired.",
  "physicians.form.pecos_not_verified_tooltip": "Not verified with PECOS.",
  "physicians.form.license_number": "License Number",
  "physicians.form.medicaid_number": "Medicaid Number",
  "physicians.form.taxonomy_code": "Taxonomy Code",
  "physicians.form.taxonomy_code_invalid": "Input must consist of exactly 10 alphanumeric characters.",
  "physicians.form.other_id_1": "Other ID 1",
  "physicians.form.other_id_2": "Other ID 2",
  "physicians.form.hospital_facility": "Hospital/Facility",
  "physicians.form.notes": "Notes",
  "physicians.form.alert_message": "Alert Message",
  "physicians.form.phone_numbers": "Phone Numbers",
  "physicians.message.search_failed": "Search failed",
  "physicians.message.load_failed": "Failed to load physicians.",
  "physicians.message.delete_in_use": "This physician is attached to one or more surgical procedures and cannot be deleted.",
  "physicians.npi_compare.title": "Compare Addresses for NPI:",
  "physicians.npi_compare.source_current": "Current",
  "physicians.npi_compare.source_registry": "NPI Registry",
  "physicians.npi_compare.select": "Select",
  "physicians.npi_compare.cancel": "Cancel",
  "therapists.empty.prompt": "Select a therapist or create a new one.",
  "therapists.list.search_placeholder": "Search therapists...",
  "therapists.list.toggle_filters": "Toggle filters",
  "therapists.list.status": "Status",
  "therapists.list.address": "Address",
  "therapists.list.phone": "Phone",
  "therapists.list.all": "All",
  "therapists.list.active": "Active",
  "therapists.list.inactive": "Inactive",
  "therapists.list.empty": "No therapists found.",
  "therapists.list.load_error_detail": "The therapists could not be loaded. Please try again.",
  "therapists.form.title.new": "New Therapist",
  "therapists.form.title.default": "Therapist",
  "therapists.form.details": "Therapist Details",
  "therapists.form.last_name": "Last Name *",
  "therapists.form.last_name_required": "Last name is required.",
  "therapists.form.first_name": "First Name *",
  "therapists.form.first_name_required": "First name is required.",
  "therapists.form.middle_name": "Middle Name",
  "therapists.form.suffix": "Suffix",
  "therapists.form.credentials": "Credentials",
  "therapists.form.street": "Street *",
  "therapists.form.city": "City *",
  "therapists.form.state": "State *",
  "therapists.form.select": "Select",
  "therapists.form.zipcode": "Zipcode *",
  "therapists.form.invalid_format": "Invalid format.",
  "therapists.form.email": "Email",
  "therapists.form.phone": "Phone Number",
  "therapists.form.fax": "Fax Number",
  "therapists.form.alert": "Alert",
  "therapists.form.alert_message": "Alert Message",
  "therapists.message.delete_in_use": "This therapist is attached to one or more patients and cannot be deleted.",
  "device_types.list.panel_title_crt": "CRT Device Types",
  "device_types.list.search_placeholder": "Search device types...",
  "device_types.list.toggle_filters": "Toggle filters",
  "device_types.list.category": "Category",
  "device_types.list.status": "Status",
  "device_types.list.body_region": "Body Region",
  "device_types.list.side": "Side",
  "device_types.list.sub_category": "Sub-Category",
  "device_types.list.all": "All",
  "device_types.list.active": "Active",
  "device_types.list.inactive": "Inactive",
  "device_types.list.empty": "No device types found.",
  "device_types.list.load_error_detail": "The device types could not be loaded. Please try again.",
  "deviceTypes.message.delete_in_use": "This device is attached to one or more prescriptions or templates and cannot be deleted.",
  "work_schedules.day.sunday": "Sunday",
  "work_schedules.day.monday": "Monday",
  "work_schedules.day.tuesday": "Tuesday",
  "work_schedules.day.wednesday": "Wednesday",
  "work_schedules.day.thursday": "Thursday",
  "work_schedules.day.friday": "Friday",
  "work_schedules.day.saturday": "Saturday",
  "work_schedules.detail.add_entry": "Add Entry",
  "work_schedules.detail.time.hours": "Hours",
  "work_schedules.detail.time.minutes": "Minutes",
  "work_schedules.detail.time.hours_placeholder": "HH",
  "work_schedules.detail.time.minutes_placeholder": "MM",
  "work_schedules.detail.time.toggle_meridian": "Toggle AM/PM",
  "work_schedules.detail.time.am": "AM",
  "work_schedules.detail.time.pm": "PM",
  "work_schedules.detail.day": "Day",
  "work_schedules.detail.start_time": "Start Time",
  "work_schedules.detail.end_time": "End Time",
  "work_schedules.detail.branch": "Branch",
  "work_schedules.detail.edit_row": "Edit",
  "work_schedules.detail.save_row": "Save",
  "work_schedules.detail.cancel_row": "Cancel edit",
  "work_schedules.detail.delete_row": "Delete",
  "work_schedules.detail.empty": "No work schedules found.",
  "work_schedules.detail.validation_invalid_time": "Enter a time between 1:00 and 12:59 and choose AM or PM.",
  "work_schedules.detail.validation_required_time": "Time is required.",
  "work_schedules.detail.no_default_branch_summary": "No Default Branch",
  "work_schedules.detail.no_default_branch_detail": "Please select a default branch before adding a work schedule entry.",
  "work_schedules.detail.branch_load_failed_summary": "Branches Unavailable",
  "work_schedules.detail.branch_load_failed_detail": "The branch list could not be loaded. Please try again.",
  "work_schedules.detail.save_failed_summary": "Save Failed",
  "work_schedules.detail.save_failed_detail": "There was an error saving this work schedule entry. Please try again.",
  "work_schedules.detail.delete_confirm_header": "Delete Work Schedule",
  "work_schedules.detail.delete_confirm_message": "Are you sure you want to delete the Work Schedule for {{day}} ({{range}})?",
  "work_schedules.detail.delete_failed_summary": "Delete Failed",
  "work_schedules.detail.delete_failed_detail": "There was an error deleting this work schedule entry. Please try again.",
  "work_schedules.detail.load_failed_summary": "Load Failed",
  "work_schedules.detail.load_failed_detail": "The work schedule could not be loaded. Please try again.",
  "work_schedules.empty.prompt": "Select a user to view their work schedule.",
  "work_schedules.list.search_placeholder": "Search users...",
  "work_schedules.list.toggle_filters": "Toggle filters",
  "work_schedules.list.user_group": "User Group",
  "work_schedules.list.all_roles": "All",
  "work_schedules.list.empty": "No users found.",
  "work_schedules.list.load_error_detail": "The users could not be loaded. Please try again.",
  "work_schedules.list.role_load_failed_summary": "User Groups Unavailable",
  "work_schedules.list.role_load_failed_detail": "The user group list could not be loaded. Please try again.",
  "appointment_types.list.search_placeholder": "Search appointment types...",
  "appointment_types.list.show_disabled": "Show Disabled",
  "appointment_types.list.active": "Active",
  "appointment_types.list.inactive": "Disabled",
  "appointment_types.list.empty": "No appointment types found.",
  "appointment_types.list.load_error_detail": "The appointment types could not be loaded. Please try again.",
  "appointment_types.empty.prompt": "Select an appointment type or create a new one.",
  "appointment_types.form.title.new": "New Appointment Type",
  "appointment_types.form.title.default": "Appointment Type",
  "appointment_types.form.details": "Appointment Type Details",
  "appointment_types.form.name": "Name *",
  "appointment_types.form.name_required": "Name is required.",
  "appointment_types.form.duration": "Duration in Minutes *",
  "appointment_types.form.duration_required": "Duration is required and must be at least 1 minute.",
  "appointment_types.form.color": "Color *",
  "appointment_types.form.color_invalid": "Enter a 6-digit HEX color, e.g. #EC92EB.",
  "appointment_types.form.color_required": "Color is required.",
  "appointment_types.form.survey_link": "Custom Customer Survey Link",
  "appointment_types.form.active": "Active",
  "appointment_types.form.is_initial_evaluation": "Is Initial Evaluation Appointment",
  "appointment_types.form.is_delivery": "Is Delivery Appointment",
  "appointment_types.form.status_on": "Yes",
  "appointment_types.form.status_off": "No",
  "calibration_profiles.calibration.header": "1500 Form Alignment",
  "calibration_profiles.calibration.open_hint": "Open the form with Setup to align the fields before saving.",
  "calibration_profiles.calibration.loading": "Loading the form...",
  "calibration_profiles.form.title_new": "New Calibration Profile",
  "calibration_profiles.form.title_default": "Calibration Profile",
  "calibration_profiles.form.details": "Profile Details",
  "calibration_profiles.form.based_on": "Creating a new profile based on {{name}}.",
  "calibration_profiles.form.profile_name": "Profile Name *",
  "calibration_profiles.form.profile_name_placeholder": "Enter a unique profile name",
  "calibration_profiles.form.profile_name_required": "Profile name is required.",
  "calibration_profiles.form.profile_name_taken": "A calibration profile with this name already exists.",
  "calibration_profiles.form.branch": "Branch",
  "calibration_profiles.form.form_version": "Form Version",
  "calibration_profiles.form.paper_size": "Paper Size",
  "calibration_profiles.form.orientation": "Orientation",
  "calibration_profiles.form.printer_make": "Printer Make *",
  "calibration_profiles.form.printer_make_placeholder": "e.g., HP, Canon, Brother",
  "calibration_profiles.form.printer_make_required": "Printer make is required.",
  "calibration_profiles.form.printer_model": "Printer Model",
  "calibration_profiles.form.printer_model_placeholder": "e.g., LaserJet Pro, PIXMA",
  "calibration_profiles.form.created_by": "Created By",
  "calibration_profiles.form.edit_with_calibration": "Edit with calibration",
  "calibration_profiles.form.enable_review": "Enable Review",
  "calibration_profiles.form.test_claim_id": "Test Claim ID *",
  "calibration_profiles.form.test_claim_id_placeholder": "Enter a claim ID to load the form",
  "calibration_profiles.actions.setup": "Setup",
  "calibration_profiles.actions.use_as_base": "Use as Base Template",
  "calibration_profiles.actions.set_default": "Set as Default",
  "calibration_profiles.message.saved_detail": "Calibration profile saved: {{name}}",
  "calibration_profiles.message.pdf_failed": "Form not loaded",
  "calibration_profiles.message.claim_not_found": "Claim ID {{claimId}} does not exist or could not be loaded. Please enter a valid claim ID.",
  "calibration_profiles.message.form_display_failed": "The 1500 form could not be displayed. Please try again.",
  "calibration_profiles.message.harvest_failed": "The field positions could not be read from the form. Nothing was saved.",
  "calibration_profiles.message.no_fields": "No alignable fields were found on the form. Nothing was saved.",
  "calibration_profiles.message.delete_title": "Delete calibration profile?",
  "calibration_profiles.message.delete_prompt": "Are you sure you want to delete the calibration profile {{name}}? This cannot be undone.",
  "calibration_profiles.message.default_title": "Set default profile?",
  "calibration_profiles.message.default_prompt": "Set {{name}} as your default 1500 form printer profile?",
  "calibration_profiles.message.default_set": "Default profile set",
  "calibration_profiles.message.default_set_detail": "{{name}} is now your default profile.",
  "calibration_profiles.message.default_failed": "Default not set",
  "calibration_profiles.message.default_error": "Your default profile could not be updated. Please try again.",
  "calibration_profiles.list.search_placeholder": "Search by profile name...",
  "calibration_profiles.list.toggle_filters": "Toggle filters",
  "calibration_profiles.list.printer_make": "Printer Make",
  "calibration_profiles.list.printer_make_placeholder": "e.g., HP, Canon",
  "calibration_profiles.list.printer_model": "Printer Model",
  "calibration_profiles.list.printer_model_placeholder": "e.g., LaserJet Pro",
  "calibration_profiles.list.branch": "Branch",
  "calibration_profiles.list.branch_placeholder": "All",
  "calibration_profiles.list.default": "Default",
  "calibration_profiles.list.created_by": "Created by:",
  "calibration_profiles.list.empty": "No calibration profiles found.",
  "calibration_profiles.list.load_error_detail": "The calibration profiles could not be loaded. Please try again.",
  "calibration_profiles.empty.prompt": "Select a calibration profile or create a new one.",
  "menu.maintenance.scheduling": "Scheduling",
  "menu.maintenance.scheduling.appointment_types": "Appointment Types",
  "menu.maintenance.scheduling.delivery_locations": "Delivery Locations",
  "menu.maintenance.scheduling.work_schedules": "Work Schedules",
  "menu.maintenance.system_settings": "System Settings",
  "menu.maintenance.templates": "Templates",
  "menu.maintenance.templates.form1500": "1500 Forms",
  "menu.maintenance.templates.notes": "Notes",
  "menu.maintenance.templates.file_types": "File Types",
  "menu.maintenance.templates.tasks": "Tasks",
  "menu.maintenance.templates.checklist_templates": "Checklist Templates",
  "menu.maintenance.templates.hcpcs_templates": "HCPCS Templates",
  "menu.maintenance.templates.fabrication_templates": "Fabrication Templates",
  "menu.maintenance.templates.justifications": "Justifications",
  "menu.maintenance.templates.print_screens": "Print Screens",
  "menu.maintenance.templates.form_templates": "Form Templates",
  "topbar.patient_search.placeholder": "Search Patient by Name, ID, or Phone",
  "topbar.patient_search.empty": "No patients found",
  "patient.search.error.summary": "Patient search failed",
  "patient.search.error.detail": "Could not load patients. Please try again.",
  "allPatients.search.error.summary": "Patient search failed",
  "allPatients.search.error.detail": "There was a problem searching for patients.",
  "maintenance.actions.actions": "Actions",
  "maintenance.actions.new": "New",
  "maintenance.actions.cancel": "Cancel",
  "maintenance.actions.save": "Save Changes",
  "maintenance.actions.delete": "Delete",
  "maintenance.actions.more": "More actions",
  "filters.actions.more_filters": "More filters",
  "filters.actions.clear_filters": "Clear Filters",
  "maintenance.actions.retry": "Retry",
  "maintenance.actions.search": "Search",
  "maintenance.actions.reset": "Reset",
  "maintenance.list.searching": "Searching...",
  "maintenance.list.shown_of": "shown of",
  "maintenance.list.match": "match",
  "maintenance.list.matches": "matches",
  "maintenance.form.unsaved": "Unsaved changes",
  "maintenance.form.street_placeholder": "Street",
  "maintenance.form.city_placeholder": "City",
  "maintenance.form.zipcode_placeholder": "Zip",
  "maintenance.form.email_placeholder": "example@email.com",
  "maintenance.message.discard_title": "Discard unsaved changes?",
  "maintenance.message.discard_prompt": "You have unsaved changes on this page. If you leave, your changes will be lost.",
  "maintenance.message.discard": "Discard Changes",
  "maintenance.message.stay": "Stay on Page",
  "maintenance.message.possible_duplicate": "Possible Duplicate",
  "maintenance.message.duplicate_prompt": "This appears to be a duplicate and may already have been created. Would you like to continue anyway?",
  "maintenance.message.continue": "Continue",
  "maintenance.message.duplicate_check_failed": "Duplicate check failed",
  "maintenance.message.duplicate_check_error": "Could not check for duplicates. Please try again.",
  "maintenance.message.saved": "Saved",
  "maintenance.message.save_success": "Your changes have been saved.",
  "maintenance.message.save_failed": "Save failed",
  "maintenance.message.save_error": "There was an error saving your changes. Please try again.",
  "maintenance.message.delete_title": "Delete this record?",
  "maintenance.message.delete_prompt": "Are you sure you want to delete this record? This cannot be undone.",
  "maintenance.message.deleted": "Deleted",
  "maintenance.message.delete_success": "The record has been deleted.",
  "maintenance.message.delete_failed": "Delete failed",
  "maintenance.message.delete_error": "There was an error with this delete attempt. Please contact Nymbl support.",
  "maintenance.message.delete_in_use": "This record is in use elsewhere and cannot be deleted.",
  "maintenance.templates.checklist_templates.title": "Checklist Templates",
  "maintenance.templates.checklist_templates.form.name": "Name",
  "maintenance.templates.checklist_templates.form.type": "Type",
  "maintenance.templates.checklist_templates.steps.title": "Steps",
  "maintenance.templates.checklist_templates.steps.add": "Add Step",
  "maintenance.templates.checklist_templates.steps.name": "Step Name",
  "maintenance.templates.steps.name_required": "Step name is required.",
  "maintenance.templates.checklist_templates.steps.delete_confirm": "Are you sure you want to delete this step?",
  "maintenance.templates.checklist_templates.in_use_warning": "This template is in use and cannot be deleted.",
  "maintenance.templates.checklist_templates.in_use_notice": "This template is in use and cannot be changed.",
  "maintenance.templates.checklist_templates.empty.title": "No Template Selected",
  "maintenance.templates.checklist_templates.list.load_error_detail": "The checklist templates could not be loaded. Please try again.",
  "maintenance.templates.checklist_templates.empty.message": "Select a template from the list or create a new one.",
  "maintenance.templates.checklist_templates.list.empty.message": "No checklists found.",
  "phone_number_list.type_required": "Type is required.",
  "phone_number_list.phone_number_required": "Phone number is required.",
  "purchasing.my_cart.breadcrumb.purchasing": "Purchasing",
  "purchasing.my_cart.breadcrumb.my_cart": "My Cart",
  "purchasing.my_cart.title": "My Cart",
  "purchasing.my_cart.subtitle": "Review and submit items for purchasing",
  "purchasing.my_cart.loading": "Loading",
  "purchasing.my_cart.back_to_top": "Back to top",
  "purchasing.my_cart.toolbar.items_selected": "items selected",
  "purchasing.my_cart.toolbar.select_all": "Select all",
  "purchasing.my_cart.toolbar.deselect_all": "Deselect all",
  "purchasing.my_cart.toolbar.remove": "Remove",
  "purchasing.my_cart.toolbar.save_for_later": "Save for Later",
  "purchasing.my_cart.filter.search_placeholder": "Search for patient, part number, or item...",
  "purchasing.my_cart.filter.vendor": "Vendor",
  "purchasing.my_cart.filter.purpose": "Purpose",
  "purchasing.my_cart.filter.priority": "Priority",
  "purchasing.my_cart.filter.status": "Status",
  "purchasing.my_cart.item.for": "For",
  "purchasing.my_cart.item.priority": "Priority",
  "purchasing.my_cart.item.needed_by": "Needed By",
  "purchasing.my_cart.item.branch": "Branch",
  "purchasing.my_cart.group.items": "items",
  "purchasing.my_cart.group.inventory": "Inventory",
  "purchasing.my_cart.group.saved_for_later": "Saved for Later",
  "purchasing.my_cart.item.edit": "Edit",
  "purchasing.my_cart.item.link": "Link",
  "purchasing.my_cart.item.codes_available": "codes available",
  "purchasing.my_cart.item.each": "each",
  "purchasing.my_cart.item.add_note": "Add Note",
  "purchasing.my_cart.item.notes_single": "{{count}} note",
  "purchasing.my_cart.item.notes_many": "{{count}} notes",
  "purchasing.my_cart.item.save_for_later": "Save for later",
  "purchasing.my_cart.item.move_to_cart": "Move to Cart",
  "purchasing.my_cart.item.delete": "Delete",
  "purchasing.my_cart.item.delete_title": "Remove Shopping Cart item",
  "purchasing.my_cart.remove_confirm.single_title": "Remove this item?",
  "purchasing.my_cart.remove_confirm.single_message": "This item and its notes and history will be permanently deleted.",
  "purchasing.my_cart.remove_confirm.warning_single": "Prescription is linked to this item.",
  "purchasing.my_cart.remove_confirm.dont_show_again": "Don't show this again",
  "purchasing.my_cart.remove_confirm.cancel": "Cancel",
  "purchasing.my_cart.remove_confirm.confirm": "Remove",
  "purchasing.my_cart.remove_confirm.bulk_title": "Remove {{count}} items?",
  "purchasing.my_cart.remove_confirm.bulk_message": "These items and their notes and history will be permanently deleted. This can't be undone.",
  "purchasing.my_cart.remove_confirm.warning_bulk": "Prescriptions are linked to these items.",
  "purchasing.my_cart.remove_result.removed_single": "{{name}} removed from cart",
  "purchasing.my_cart.remove_result.removed_single_unnamed": "Item removed from cart",
  "purchasing.my_cart.remove_result.removed_bulk": "{{count}} items removed from cart",
  "purchasing.my_cart.remove_result.generic_error": "Couldn't remove items from your cart. Please try again.",
  "purchasing.my_cart.remove_result.not_found": "{{name}} is no longer in your cart.",
  "purchasing.my_cart.remove_result.not_found_unnamed": "This item is no longer in your cart.",
  "purchasing.my_cart.remove_result.not_found_many": "{{count}} items are no longer in your cart.",
  "purchasing.my_cart.remove_result.out_of_branch": "You don't have access to the branch of {{name}}.",
  "purchasing.my_cart.remove_result.out_of_branch_unnamed": "You don't have access to this item's branch.",
  "purchasing.my_cart.remove_result.out_of_branch_many": "{{count}} items are at branches you can't access.",
  "purchasing.my_cart.remove_result.submitted": "{{name}} was already submitted and can't be removed.",
  "purchasing.my_cart.remove_result.submitted_unnamed": "This item was already submitted and can't be removed.",
  "purchasing.my_cart.remove_result.submitted_many": "{{count}} items were already submitted and can't be removed.",
  "purchasing.my_cart.remove_result.delete_failed": "Couldn't delete {{name}}. Try again.",
  "purchasing.my_cart.remove_result.delete_failed_unnamed": "Couldn't delete this item. Try again.",
  "purchasing.my_cart.remove_result.delete_failed_many": "Couldn't delete {{count}} items. Try again.",
  "purchasing.my_cart.submit_result.submitted_single": "{{name}} submitted for review",
  "purchasing.my_cart.submit_result.submitted_single_unnamed": "Item submitted for review",
  "purchasing.my_cart.submit_result.submitted_bulk": "{{count}} items submitted for review",
  "purchasing.my_cart.submit_result.resubmitted_single": "Item resubmitted for review",
  "purchasing.my_cart.submit_result.resubmitted_bulk": "{{count}} items resubmitted for review",
  "purchasing.my_cart.submit_result.failed": "Items could not be submitted",
  "purchasing.my_cart.submit_result.try_again": "Try again",
  "purchasing.my_cart.submit_result.not_found": "{{name}} is no longer in your cart.",
  "purchasing.my_cart.submit_result.not_found_unnamed": "This item is no longer in your cart.",
  "purchasing.my_cart.submit_result.not_found_many": "{{count}} items are no longer in your cart.",
  "purchasing.my_cart.submit_result.saved_for_later": "{{name}} is saved for later. Move it to your cart to submit it.",
  "purchasing.my_cart.submit_result.saved_for_later_unnamed": "This item is saved for later. Move it to your cart to submit it.",
  "purchasing.my_cart.submit_result.saved_for_later_many": "{{count}} items are saved for later. Move them to your cart to submit them.",
  "purchasing.my_cart.filter_result.no_longer_matches": "{{name}} was updated and no longer matches the current filters.",
  "purchasing.my_cart.selection_limit_reached": "You can select up to {{count}} items at a time.",
  "purchasing.my_cart.error.summary": "Error",
  "purchasing.my_cart.error.load_items": "Couldn't load your cart items. Please try again.",
  "purchasing.my_cart.error.load_filters": "Couldn't load the cart filters. Please try again.",
  "purchasing.my_cart.error.populate": "Couldn't populate the cart with test data.",
  "purchasing.my_cart.error.update_item.generic_error": "Couldn't update your cart item. Please try again.",
  "purchasing.my_cart.error.update_item.conflict": "This item was changed elsewhere. Refresh your cart and try again.",
  "purchasing.my_cart.error.update_item.submitted": "This item was already submitted and can no longer be edited.",
  "purchasing.my_cart.error.update_item.changed": "Someone else changed this item. It now shows the latest values.",
  "purchasing.my_cart.error.update_item.retry_limit": "This item keeps changing. Refresh your cart and try again.",
  "purchasing.my_cart.error.field.quantity.required": "Enter a quantity.",
  "purchasing.my_cart.error.field.quantity.min": "Quantity must be at least 1.",
  "purchasing.my_cart.error.field.neededByDate.invalid": "Enter a valid date (mm/dd/yyyy).",
  "purchasing.my_cart.error.field.neededByDate.past": "The needed-by date can't be in the past.",
  "purchasing.my_cart.empty.title": "Your cart is empty",
  "purchasing.my_cart.empty.description": "Items you add will appear here until Purchasing approves them.",
  "purchasing.my_cart.empty.continue_shopping": "Continue Shopping",
  "purchasing.my_cart.no_results.title": "No Results Found",
  "purchasing.my_cart.no_results.description": "Try a different search or adjust your filters.",
  "purchasing.my_cart.summary.title": "Cart Summary",
  "purchasing.my_cart.summary.subtitle": "Items to be reviewed for purchase",
  "purchasing.my_cart.summary.empty": "No items in cart",
  "purchasing.my_cart.summary.estimated_total": "Estimated total",
  "purchasing.my_cart.summary.submit_for_review": "Submit for review",
  "selects.place_of_service.placeholder": "No Place of Service Selected",
  "selects.role_select.label": "User Group",
  "selects.role_select.placeholder": "Select User Group",
  "selects.role_select.loading": "Loading...",
  "selects.role_select.required": "Field is required.",
  "selects.role_select.unavailable": "User groups are unavailable right now.",
  "tasks.form.assignee.label": "Assign To",
  "tasks.form.assignee.user": "User",
  "tasks.form.assignee.user_group": "User Group",
  "tasks.form.assignee.required": "An assignee is required.",
  "tasks.form.section.task": "Task",
  "tasks.form.section.patient": "Patient",
  "tasks.form.section.status": "Status",
  "tasks.form.name.label": "Name",
  "tasks.form.name.placeholder": "Type to search templates",
  "tasks.form.name.required": "Name is required.",
  "tasks.form.due_date.label": "Due Date",
  "tasks.form.due_date.required": "Due date is required.",
  "tasks.form.description.label": "Description",
  "tasks.form.patient.label": "Patient",
  "tasks.form.patient.placeholder": "Select Patient",
  "tasks.form.completed.label": "Completed",
  "tasks.form.actions.cancel": "Cancel",
  "tasks.form.actions.back": "Back",
  "tasks.form.actions.submit": "Submit",
  "tasks.form.save.error.summary": "Task Not Saved",
  "tasks.form.save.error.detail": "The task could not be saved. Your changes are still on the form, so you can try again.",
  "tasks.save.error.network": "Unable to reach the server. Check your internet connection and try again.",
  "tasks.save.error.unknown": "The task could not be saved. Please try again. If the issue persists please contact support.",
  "notifications.page.title": "Notifications",
  "notifications.page.subtitle": "View Notifications",
  "notifications.bell.label": "Notifications",
  "notifications.compose.title_view": "View Message",
  "notifications.compose.title_reply": "Reply",
  "notifications.compose.title_reply_all": "Reply All",
  "notifications.compose.to": "To",
  "notifications.compose.from": "From",
  "notifications.compose.patient": "Patient",
  "notifications.compose.message": "Message",
  "notifications.compose.send": "Send",
  "notifications.compose.reply": "Reply",
  "notifications.compose.cancel": "Cancel",
  "notifications.compose.thread_heading": "Conversation",
  "notifications.compose.thread_error": "The earlier messages in this conversation could not be loaded.",
  "notifications.compose.no_recipients": "This message has no other recipients, so there is nobody to reply to.",
  "notifications.compose.success.summary": "Message sent",
  "notifications.compose.success.detail": "Your reply has been delivered.",
  "notifications.compose.error.summary": "Message not sent",
  "notifications.compose.error.detail": "The reply could not be sent. Please try again.",
  "notifications.test.page_title": "Send Test Notification",
  "notifications.test.page_subtitle": "Verify live notification delivery",
  "notifications.test.description": "Sends a real notification to the chosen user through the same path a system event uses. Use it to confirm the bell badge and panel update without a page reload.",
  "notifications.test.recipient_label": "Send to",
  "notifications.test.message_label": "Message",
  "notifications.test.default_message": "Test notification sent from System Settings",
  "notifications.test.send": "Send Test Notification",
  "notifications.test.success.summary": "Test notification sent",
  "notifications.test.success.detail": "The recipient's bell should update without a reload.",
  "notifications.test.error.summary": "Could not send the test notification",
  "notifications.test.error.detail": "The notification was not sent. Please try again.",
  "notifications.panel.title": "Notifications",
  "notifications.panel.unread_tab": "Unread",
  "notifications.panel.read_tab": "Read",
  "notifications.panel.mark_all_read": "Mark All Read",
  "notifications.panel.delete_all": "Delete All",
  "notifications.panel.view_all": "View All",
  "notifications.panel.empty_unread": "You have no unread notifications",
  "notifications.panel.empty_read": "You have no read notifications",
  "notifications.panel.read_cap": "Showing the most recent 30. Use View All for older history.",
  "notifications.panel.unread_badge_label": "unread notifications",
  "notifications.panel.confirm.mark_all.header": "Mark all as read",
  "notifications.panel.confirm.mark_all.message": "Are you sure you would like to mark all notifications as read?",
  "notifications.panel.confirm.delete_all.header": "Delete read notifications",
  "notifications.panel.confirm.delete_all.message": "Are you sure you would like to delete all read notifications? Unread notifications are kept.",
  "notifications.panel.confirm.accept": "Yes",
  "notifications.panel.confirm.reject": "No",
  "notifications.toast.new_notification": "New notification",
  "notifications.toast.new_error_notification": "Action needed",
  "notifications.filter.search": "Search",
  "notifications.filter.status.label": "Status",
  "notifications.filter.status.unread": "Unread",
  "notifications.filter.status.read": "Read",
  "notifications.filter.status.sent": "Sent",
  "notifications.filter.status.all": "View All",
  "notifications.filter.date_range.label": "Between",
  "notifications.list.empty": "There are no notifications to display",
  "notifications.list.error.title": "Notifications could not be loaded",
  "notifications.list.error.body": "There was a problem loading your notifications. Please try again.",
  "notifications.list.error.summary": "Notifications failed to load",
  "notifications.list.error.detail": "There was a problem loading your notifications.",
  "notifications.column.date": "Date",
  "notifications.column.category": "Category",
  "notifications.column.message": "Message",
  "notifications.column.patient": "Patient",
  "notifications.column.from": "From",
  "notifications.column.to": "To",
  "notifications.column.status": "Status",
  "notifications.row.from": "From",
  "notifications.row.to": "To",
  "notifications.row.read": "Message has been read",
  "notifications.row.unread": "Unread",
  "notifications.category.general": "General",
  "notifications.category.billing": "Billing",
  "notifications.category.clerical": "Clerical",
  "notifications.category.error": "Error",
  "notifications.actions.retry": "Retry",
  "notifications.actions.search": "Search",
  "notifications.actions.mark_read": "Mark as Read",
  "notifications.actions.delete": "Delete",
  "notifications.actions.view": "View",
  "notifications.actions.reply": "Reply",
  "notifications.actions.reply_all": "Reply All",
  "notifications.actions.create_task": "Create Task",
  "notifications.actions.open_task": "Open Task",
  "notifications.mark_read.error.summary": "Could not mark as read",
  "notifications.mark_read.error.detail": "The notification could not be marked as read. Please try again.",
  "notifications.delete.error.summary": "Could not delete notification",
  "notifications.delete.error.detail": "The notification could not be deleted. Please try again.",
  "file_upload_dialog.save": "Save",
  "file_upload_dialog.direct_scan": "Direct Scan"
}
